import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { deleteMeetingRoom } from '../../../../actions/meetingRoom.js';
import RightPanel from './rightPanel';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';
import moment from 'moment';
import { Icon, Message } from 'semantic-ui-react';

export default function DeleteMeetingRoomContent(props) {
  const dispatch = useDispatch();
  const timezone = useSelector((state) => state.usersReducer.userProfile.timezoneOffsetNow);

  const deletecurrentMeetingRoom = (meetingRoomForm) => {
    dispatch(deleteMeetingRoom(meetingRoomForm));
  };

  const renderCenterContent = () => {
    let lastTimeUsed = props.meetingRoomForm.lastTimeMeetingRoomUsed;
    let lastTimeUsedMessage = APP.LANGUAGE.DeleteMeeting.LastNotUsedMessage;
    if (lastTimeUsed && (timezone == 0 || timezone)) {
      // Use moment to generate format
      let lastTimeUsedTime = moment.utc(lastTimeUsed).utcOffset(timezone);
      let lastTimeUsedFormat = lastTimeUsedTime.format('DD MMMM YYYY hh:mm A');
      lastTimeUsedMessage = APP.LANGUAGE.DeleteMeeting.LastUsedMessage + lastTimeUsedFormat;
    }

    return (
      <div className="mrtm">
        <div className="title-sms">{lastTimeUsedMessage}</div>
        <div className="ui pdtm  segment ignored info attached borderless max-width brdr-radius-null mrbxl   bg-transparent">
          <div className="mrtm">
            <Message icon className="borderless bg-transparent pdlnull pdrnull">
              <Icon name="exclamation circle" className="mrrm color-warning" />
              <Message.Content>
                <div className="title-sms">{APP.LANGUAGE.DeleteMeeting.Info}</div>
              </Message.Content>
            </Message>
          </div>
        </div>
      </div>
    );
  };

  return (
    <Modal show={true} hideWhenClickAway={true} className={'delete-meeting'}>
      <PopupHeader
        title={APP.LANGUAGE.DeleteMeeting.Title}
        subtitle={props.meetingRoomForm.name + ' (' + props.meetingRoomForm.organisationAbbreviatedName + ')'}
        hideHelp={true}
      />
      <div className="content">
        <div className="main-ui-container meeting-room-create-update">
          <div id="righthandfloatingpanel">
            <div className="right ui rail">
              <div className="ui sticky">
                <RightPanel
                  deletecurrentMeetingRoom={deletecurrentMeetingRoom}
                  meetingRoomForm={props.meetingRoomForm}
                  cbAfterDeletion={props.cbAfterDeletion}
                />
              </div>
            </div>
            {renderCenterContent()}
            <div className="bottom-rail-with-left-and-right-content mrtnull">
              <RightPanel
                deletecurrentMeetingRoom={deletecurrentMeetingRoom}
                meetingRoomForm={props.meetingRoomForm}
                cbAfterDeletion={props.cbAfterDeletion}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
